import React from "react";
import { useTranslation } from "react-i18next";
import { X, Users } from "lucide-react";

// Click-to-inspect drill-down for agent clusters. `expanded` is driven by the
// canvas camera (semantic zoom): zooming in past a threshold auto-expands members.
export default function AgentClusterInspector({ clusters, selectedId, expanded, onSelect, onClose }) {
  const { t } = useTranslation();
  const selected = clusters.find((c) => c.id === selectedId);
  return (
    <div data-testid="agent-cluster-inspector">
      <div className="flex items-center justify-between mb-2">
        <div className="text-[10px] uppercase tracking-[0.18em] text-[var(--qn-foreground-subtle)] font-semibold">{t("decisionGraph.agents.title")}</div>
        {selected && (
          <button onClick={onClose} data-testid="agent-inspector-close" aria-label={t("decisionGraph.agents.close")}
            className="text-[var(--qn-foreground-subtle)] hover:text-[var(--qn-foreground)]"><X className="w-3.5 h-3.5" /></button>
        )}
      </div>
      {!selected && (
        <div className="text-[11px] text-[var(--qn-foreground-subtle)] mb-2" data-testid="agent-inspect-hint">
          {t("decisionGraph.agents.inspectHint")}
        </div>
      )}
      <div className="flex flex-wrap gap-1.5">
        {clusters.map((c) => (
          <button key={c.id} data-testid={`agent-cluster-${c.id}`} onClick={() => onSelect(c.id)}
            aria-pressed={selectedId === c.id}
            className={`inline-flex items-center gap-1 rounded-md border px-2 py-1 text-[11px] focus:outline-none focus:ring-2 focus:ring-[var(--qn-primary)] ${
              selectedId === c.id
                ? "border-[var(--qn-border-active)] text-[var(--qn-primary)] bg-[var(--qn-primary-muted)]"
                : "border-[var(--qn-border)] text-[var(--qn-foreground-muted)]"}`}>
            <Users className="w-3 h-3" />{c.count > 1 ? t("decisionGraph.agents.members", { count: c.count }) : t("decisionGraph.agents.cluster")}
          </button>
        ))}
      </div>
      {selected && (expanded || selected.count <= 8) && (
        <div className="mt-2 grid grid-cols-4 gap-1" data-testid="agent-cluster-members">
          {selected.members.map((m) => (
            <span key={m} className="rounded border border-[var(--qn-border)] bg-[var(--qn-surface)] px-1.5 py-1 text-[10px] font-mono text-[var(--qn-foreground-muted)] text-center">#{m + 1}</span>
          ))}
        </div>
      )}
      {selected && !expanded && selected.count > 8 && (
        <div className="mt-2 text-[10px] text-[var(--qn-foreground-subtle)]" data-testid="agent-zoom-hint">{t("decisionGraph.agents.zoomHint")}</div>
      )}
    </div>
  );
}
